<template>
<div class="tabs">
    <ul class="tabs__tabs">
        <li
            class="tabs__tab"
            role="presentation"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="{'tabs__tab--active': tab.isActive}"
        >
            <a  role="tab"
                class="tabs__tab-button"
                v-html="tab.header"
                :href="tab.hash"
                :aria-controls="tab.hash"
                :aria-selected="tab.isActive"
                @click.stop.prevent="selectTab(tab.hash, $event)"
            ></a>
        </li>
    </ul>
    <div class="tabs__panels">
        <slot />
    </div>
</div>
</template>
<script>
import expiringStorage from '../vendor/expiring-storage';
export default {
    props: {
        cacheLife: {default: 5}
    },
    data() {
        return {
            tabs: [],
            activeTabHash: '',
            lastActiveTabHash: ''
        };
    },
    computed: {
        storageKey() {
            return `tabs.cache.${window.location.host}${window.location.pathname}`;
        }
    },
    created() { this.tabs = this.$children; },
    mounted() {
        const previousSelectedTabHash = expiringStorage.get(this.storageKey);
        if (this.findTab(previousSelectedTabHash)) {
            this.selectTab(previousSelectedTabHash);
        } else if (this.tabs.length) {
            this.selectTab(this.tabs[0].hash);
        }
    },
    methods: {
        findTab(hash) { return this.tabs.find(tab => tab.hash === hash); },
        selectTab(selectedTabHash, e) {
            const selectedTab = this.findTab(selectedTabHash);
            if (selectedTab && this.lastActiveTabHash !== selectedTab.hash) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.hash === selectedTab.hash);
                });
                this.activeTabHash = selectedTab.hash;
                this.lastActiveTabHash = this.activeTabHash = selectedTab.hash;
                expiringStorage.set(this.storageKey, selectedTab.hash, this.cacheLife);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/tabs.vue